const PAGE_COUNTRIES = {
  ru: 'ru',
  es: 'es',
  pt: 'pt',
  br: 'br'
};

export const getPhoneCountry = (browserLanguages, pageLocale, supportedCountries = []) => {
  const supported = new Set(supportedCountries.map((country) => country.toLowerCase()));
  const isSupported = (country) => /^[a-z]{2}$/.test(country) && (!supported.size || supported.has(country));

  for (const language of browserLanguages || []) {
    try {
      const region = new Intl.Locale(language).region?.toLowerCase();
      if (region && isSupported(region)) return region;
    } catch (_error) {
      // Ignore malformed browser language tags and try the next one.
    }
  }

  const fallback = PAGE_COUNTRIES[pageLocale?.toLowerCase()] || '';
  return isSupported(fallback) ? fallback : '';
};
